import React from 'react'
import BentoboxGrid from '../bentobox-grid'

const TypeTwoOutside = (props) => <BentoboxGrid {...props} inside={false} featured={true} />

export default TypeTwoOutside
